module.exports = __webpack_public_path__ + "media/focus_skill/focus_skill_star_green-50345169.svg";